import * as React from "react"
const SvgTable = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.588Q21 4.175 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21H5q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19M19 9H5V5h14zm-5.325 2v8h-3.35v-8zm-5.35 0v8H5v-8zM19 11v8h-3.325v-8z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgTable
